<template lang="pug">
.nuh
    .row.ac
        h1 NUH
        h3 TIPOS DE SERVIÇOS
    // Button(:layout="!open?'green-go':'red-go'" @click="open=!open" title="NOVO" :class="open?'fa-times':'fa-plus'").fa
    Loader(v-if="loader" layout="small")
    template(v-else)
        Supporter(:cb="(sp)=>form.id_doutor=sp.id")
        .form(v-if="form.id_doutor")
            .row.js(style="padding: 0 20px")
                .col
                    label Complemento
                    input(type="text" v-model="form.complemento" placeholder="Complemento" )
                .col.ac
                    label N° de APs
                    b(style="font-size: 30px") {{conf.aps}}
            .aps.row.wp
                .bk.col(v-for="ap in conf.aps" :key="'ap'+ap")
                    label Valor LPU {{ap}} AP
                    <Money @change.native="({ target: { value } })=>up(value,`valor_job_orcado_nuh_${ap<10?'0'+ap:ap}_ap`)" v-bind="money" required />
                    .inf.col Valor Orçado {{ap}} AP
                        b {{form[`valor_job_orcado_nuh_${ap<10?'0'+ap:ap}_ap`] | money}}
            Button(@click="cad" layout="green-go") CADASTRAR
</template>

<script>
import { mapActions } from "vuex";
import { Money } from "v-money";
import Button from "@/components/Button";
import Loader from "@/components/Loader";
import Supporter from "@/views/admin/components/Supporter";

export default {
    name: "Nuh",
    components: { Button, Supporter, Money, Loader },
    data() {
        return {
            open: false,
            loader: true,
            conf: {},
            money: {
                decimal: ",",
                thousands: ".",
                precision: 2,
                masked: false,
            },
            form: { id_doutor: null }
        };
    },
    methods: {
        ...mapActions("admin", ["NUH_GET", "NUH_POST"]),
        up(value, k) {
            this.form[k] = parseFloat(parseFloat(value.toString().replace('.', '').replace(',', '.')) / this.conf.proporcao_custo_orcado).toFixed(2)
            this.form = { ...this.form }
        },
        async cad() {
            this.loader = true
            if (this.form.complemento && !this.form.complemento.length) delete this.form.complemento
            await this.NUH_POST(this.form)
            this.form = { id_doutor: null }
            this.loader = false
        },
        async load() {
            this.loader = true
            let { data } = await this.NUH_GET()
            if (data) this.conf = data
            this.loader = false
        },
    },
    beforeMount() {
        this.load()
    }

};
</script>

<style lang="sass" scoped>
@use "@/assets/scss/vars.scss" as *
.nuh
    @include page
    h1
        font-size: 38px
        height: 10px
        margin-top: 2px
        margin-bottom: 40px
    h3
        color: $font-color
        margin-left: 12px
    .aps
        padding: 20px 10px
        margin-top: 16px
        .bk
            margin-right: 12px
    .form
        @include form
        @include border 
        background: white
        border-radius: 12px
        padding: 20px  
        padding-top: 0
        button
            margin-top: 10px

</style>